import { RouteType } from "../../../types/RouteType";

const TruckDispatchWorkflowRoute: RouteType = {
  name: "Truck Dispatch",
  path: "/workflows/truck-dispatch",
  layout: "/app",
  requiresAuth: true,
  viewportCard: {
    header: {
      component: () => import("./TruckDispatchWorkflowHeader"),
      title: "Dispatch Truck",
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./TruckDispatchWorkflow"),
      grayBackground: true,
    },
  },
  requiresPermission: false,
  beforeEnter: async () => {
    return true;
  },
};

export default TruckDispatchWorkflowRoute;
